var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDesktopTwitter(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 32,
    viewBox: "0 0 39 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34.656 8.04547C34.6795 8.38586 34.6795 8.72626 34.6795 9.06979C34.6795 19.5372 26.7263 31.6094 12.1835 31.6094V31.6031C7.8875 31.6094 3.68076 30.3765 0.0642395 28.0517C0.688911 28.127 1.31671 28.1647 1.94608 28.1663C5.50624 28.1694 8.96463 26.9725 11.7655 24.7686C8.38223 24.7043 5.41543 22.4941 4.37901 19.2674C5.56416 19.4965 6.78532 19.4494 7.94856 19.131C4.26003 18.3843 1.60635 15.1372 1.60635 11.3663C1.60635 11.3317 1.60635 11.2988 1.60635 11.2659C2.70539 11.8792 3.93595 12.2196 5.19468 12.2572C1.72064 9.93096 0.649771 5.30037 2.74766 1.67998C6.76184 6.629 12.6845 9.63763 19.0423 9.95606C18.4051 7.20469 19.2756 4.32155 21.3297 2.38743C24.5141 -0.611784 29.5224 -0.458058 32.5158 2.73096C34.2865 2.38116 35.9836 1.73018 37.5367 0.807824C36.9464 2.64155 35.7112 4.1992 34.0611 5.189C35.6282 5.0039 37.1594 4.58351 38.6013 3.94194C37.5398 5.53567 36.2028 6.9239 34.656 8.04547Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDesktopTwitter);
export default __webpack_public_path__ + "static/media/DesktopTwitter.f1558acdcf9e199f09e57c39da330db1.svg";
export { ForwardRef as ReactComponent };